class HighChartsThemeProviderService extends BaseService
	@register angular.module 'App.Service'
	@inject 'localStorageService', 'ConfigurationService', '$rootScope'
	themes = {
			areaTheme: {}
			columnTheme: {}
		}
	initialize: ->

		_this = @

		themes.columnTheme.basic = {
			colors: ['rgba(22, 204, 83, 0.4)', '#16cc53']
			xAxis: {
				showEmpty: true,
				title: '',
				lineColor: 'rgba(46, 60, 70, 0)',
				gridLineColor: 'rgba(46, 60, 70, 0.1)',
				tickWidth: 0,
				startOnTick: false,
				labels: {
					style: {
						color: 'rgba(46, 60, 70, 0.3)',
						fontWeight: '700'
					}
				}
			},
			yAxis: {
				showEmpty: true,
				useHTML: true,
				title: '',
				gridLineColor: 'rgba(46, 60, 70, 0.1)',
				labels: {
					align: 'left',
					x:0,
					y:0,
					borderColor:'#f00',
					borderWidth:10,
					style: {
						color: 'rgba(46, 60, 70, 0.3)',
						fontWeight: '700',
						textTransform: 'uppercase'
					}
				}
			}
			plotOptions: {
				series: {
					marker: {
						states: {
							hover: {
								enabled: false
							}
						}
					}
					pointWidth: 71
					states: {
						hover: {
							halo: {}
							borderColor: '#16cc53'
							brightness: 0
						}
					}
					borderWidth: 4
					borderColor: 'rgba(22, 204, 83, 0.0)'
					column: {}
				}
			},
			legend:  {
				enabled: false
			}
			chart: {
				margin: [60, 0, 25, 0]
				backgroundColor:'rgba(255, 255, 255, 0)'
				spacingTop: 0
				type: 'column'
			},
			title: {
				style: {'display': 'none'}
				align: 'left'
				y: 0
				x: -10
			},
			credits: {
				enabled: false
			},
			lang: {
				decimalPoint: ', '
				thousandsSep: '.'
			}
			tooltip: {
				crosshairs: true
				backgroundColor: '#16cc53'
				borderRadius: 5
				borderWidth: 0
				shadow: false,
				headerFormat: ''
				pointFormat: '<span style="opacity:0.7;font-weight:700;text-transform: uppercase;">{series.name}</span><br><span style="font-size:1.8em;">{point.y}</span>'
				footerFormat: ''
				valueDecimals: 2,
				valuePrefix: '',
				valueSuffix: '',
				style: {
					padding: 17,
					margin: 0,
					color: '#fff',
					fontSize: '1em',
					fontWeight: '400',
				}
			}
		}

		themes.areaTheme.dynamic = JSON.parse(JSON.stringify(themes.columnTheme.basic)) # Use JSON functions to clone the object.

		color = _this.getConfig 'Backoffice.Theme.Chart.Dynamic.Colors'

		if color? and typeof color == 'string'
			alpha = (color.substr -2, 1) / 2
			faded = (color.substr 0, color.length-2) + alpha + ')'

		themes.areaTheme.dynamic.colors = [
			color
			faded if faded?
		]

		themes.areaTheme.dynamic.colors = [color, faded]
		themes.areaTheme.dynamic.chart.type = 'areaspline'
		themes.areaTheme.dynamic.tooltip.backgroundColor = _this.getConfig 'Backoffice.Theme.Chart.Dynamic.Tooltip.BackgroundColor'
		themes.areaTheme.dynamic.tooltip.crosshairs = {width: 1, color: _this.getConfig ('Backoffice.Theme.Chart.Dynamic.Tooltip.Crosshairs.Color')}
		themes.areaTheme.dynamic.tooltip.pointFormat = '<span style="opacity:0.7;font-weight:700;text-transform: uppercase;">{series.name}</span><br><span style="font-size:1.8em;">{point.y}</span>'
		themes.areaTheme.dynamic.plotOptions.series.marker.states.hover.lineColor = _this.getConfig 'Backoffice.Theme.Chart.Dynamic.PlotOptions.Series.Marker.States.Hover.LineColor'

		themes.areaTheme.dynamic.plotOptions.series.lineWidth = 0
		themes.areaTheme.dynamic.plotOptions.series.fillOpacity = 0.4
		themes.areaTheme.dynamic.plotOptions.series.marker.lineWidth = 0
		themes.areaTheme.dynamic.plotOptions.series.marker.enabled = true
		themes.areaTheme.dynamic.plotOptions.series.marker.states.hover.lineWidth = 1
		themes.areaTheme.dynamic.plotOptions.series.marker.states.hover.enabled = true
		themes.areaTheme.dynamic.plotOptions.series.states.hover.halo.size = 0
		themes.areaTheme.dynamic.plotOptions.series.marker.radius = 5

		themes.areaTheme.static = JSON.parse(JSON.stringify(themes.areaTheme.dynamic)) # Use JSON functions to clone the object.
		themes.areaTheme.static.colors = [_this.getConfig 'Backoffice.Theme.Chart.Static.Colors']
		themes.areaTheme.static.chart.type = 'areaspline'
		themes.areaTheme.static.tooltip.backgroundColor = _this.getConfig 'Backoffice.Theme.Chart.Static.Tooltip.BackgroundColor'
		themes.areaTheme.static.tooltip.crosshairs = {width: 1, color: _this.getConfig ('Backoffice.Theme.Chart.Static.Tooltip.Crosshairs.Color')}
		themes.areaTheme.static.tooltip.pointFormat = '<span style="font-size:1.8em;">{point.y}</span>'
		themes.areaTheme.static.plotOptions.series.marker.states.hover.lineColor = _this.getConfig 'Backoffice.Theme.Chart.Static.PlotOptions.Series.Marker.States.Hover.LineColor'

	getConfig: (key) ->
		return @ConfigurationService.get key, true
		#configuration = @localStorageService.get('User.Configuration')

		# if configuration
		# 	i = _.find(configuration.keys, (val) -> val.identifier == key)
		# 	if i then return i.value else return false

	get: (themeType, theme) ->
		if themes[themeType][theme]?
			return themes[themeType][theme]
